export const portfolioData = [
  // Videos - Animations (newest first)
  {
    id: 'video-scott-lamb',
    type: 'video',
    title: 'Scott and Lamb Animation',
    date: 'Jan. 2026',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/BbXwqgj-4es/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/BbXwqgj-4es',
    videoPreview: 'https://www.youtube.com/embed/BbXwqgj-4es?autoplay=1&mute=1&controls=0&loop=1&playlist=BbXwqgj-4es'
  },
  {
    id: 'video-5',
    type: 'video',
    title: 'Creepy Cable: Romance Scene',
    date: 'Sept. - Nov. 2025',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/62Y4LGsVkL4/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/62Y4LGsVkL4',
    videoPreview: 'https://www.youtube.com/embed/62Y4LGsVkL4?autoplay=1&mute=1&controls=0&loop=1&playlist=62Y4LGsVkL4'
  },
  {
    id: 'video-7',
    type: 'video',
    title: 'ANIM 332: Lipsync',
    date: 'Oct. 2025',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/H1UZKp58fXI/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/H1UZKp58fXI',
    videoPreview: 'https://www.youtube.com/embed/H1UZKp58fXI?autoplay=1&mute=1&controls=0&loop=1&playlist=H1UZKp58fXI'
  },
  {
    id: 'video-1',
    type: 'video',
    title: 'Head Turn (Ryan)',
    date: 'April 2025',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/bnA8zRIRiYU/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/bnA8zRIRiYU',
    videoPreview: 'https://www.youtube.com/embed/bnA8zRIRiYU?autoplay=1&mute=1&controls=0&loop=1&playlist=bnA8zRIRiYU'
  },
  {
    id: 'video-2',
    type: 'video',
    title: 'Dylan Sings "Bye Bye Bye"',
    date: 'April 2025',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/ZTjhwrv7ilM/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/ZTjhwrv7ilM',
    videoPreview: 'https://www.youtube.com/embed/ZTjhwrv7ilM?autoplay=1&mute=1&controls=0&loop=1&playlist=ZTjhwrv7ilM'
  },
  {
    id: 'video-4',
    type: 'video',
    title: 'Lipsync (Ryan)',
    date: 'April 2025',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/YDCHio1JAE8/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/YDCHio1JAE8',
    videoPreview: 'https://www.youtube.com/embed/YDCHio1JAE8?autoplay=1&mute=1&controls=0&loop=1&playlist=YDCHio1JAE8'
  },
  {
    id: 'video-8',
    type: 'video',
    title: 'ANIM 190: Film Recreation',
    date: 'Oct. 2024',
    category: 'animations',
    thumbnail: 'https://img.youtube.com/vi/NY-IrBJJqbc/0.jpg',
    videoUrl: 'https://www.youtube.com/embed/NY-IrBJJqbc',
    videoPreview: 'https://www.youtube.com/embed/NY-IrBJJqbc?autoplay=1&mute=1&controls=0&loop=1&playlist=NY-IrBJJqbc'
  },

  // Videos - Rigging (newest first)
  {
    id: 'video-rig-ryan',
    type: 'video',
    title: 'Ryan Rig Demo',
    date: 'Aug. 2025',
    category: 'rigging',
    thumbnail: 'https://img.youtube.com/vi/5vhgy39oGy4/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/5vhgy39oGy4',
    videoPreview: 'https://www.youtube.com/embed/5vhgy39oGy4?autoplay=1&mute=1&controls=0&loop=1&playlist=5vhgy39oGy4'
  },
  {
    id: 'video-9',
    type: 'video',
    title: 'ANIM 190: Scott and Ramona Rigs',
    date: 'Oct. 2024',
    category: 'rigging',
    thumbnail: 'https://img.youtube.com/vi/VoivgPrGdIU/maxresdefault.jpg',
    videoUrl: 'https://www.youtube.com/embed/VoivgPrGdIU',
    videoPreview: 'https://www.youtube.com/embed/VoivgPrGdIU?autoplay=1&mute=1&controls=0&loop=1&playlist=VoivgPrGdIU'
  },

  // Storyboards (newest first)
  {
    id: 'storyboard-1',
    type: 'pdf',
    title: 'Sand Wars: End Intercut',
    date: 'Jul 2026',
    category: 'storyboards',
    categoryLabel: 'Storyboard',
    thumbnail: '/storyboard-endintercut-thumb-p2.png',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_09662520-4421-4e1d-9215-1fc6eaba455a/artifacts/5q5kowvv_SW_ST_End_Intercut_KS_V001.pdf',
    totalPages: 18
  },
  {
    id: 'storyboard-2',
    type: 'video',
    title: 'Creepy Cable Animatic',
    date: 'Sept. 2025',
    category: 'storyboards',
    categoryLabel: 'Animatic',
    thumbnail: '/creepy-cable-animatic-poster-v2.jpg',
    videoFile: '/creepy-cable-animatic.mp4'
  },
  {
    id: 'storyboard-3',
    type: 'pdf',
    title: 'After the New York Show Storyboard',
    date: 'May 2025',
    category: 'storyboards',
    categoryLabel: 'Storyboard',
    thumbnail: '/after-ny-thumb-v2.png',
    pdfUrl: 'https://sewell-portfolio-v2.preview.emergentagent.com/api/pdf/after-ny-show-storyboard',
    totalPages: 54
  },

  // Character Designs (newest first)
  {
    id: 'pdf-1',
    type: 'pdf',
    title: 'King Character Process Book',
    date: 'Jun. 2026',
    category: 'characterdesigns',
    categoryLabel: 'characterdesigns',
    thumbnail: '/king-thumb.png',
    pdfUrl: 'https://sewell-portfolio-v2.preview.emergentagent.com/api/pdf/process-book',
    totalPages: 11
  },
  {
    id: 'pdf-3',
    type: 'image',
    title: 'Chester Character Design',
    date: 'Jun. 2026',
    category: 'characterdesigns',
    categoryLabel: 'characterdesigns',
    thumbnail: '/chester-page1.png',
    image: '/chester-page1.png'
  },
  {
    id: 'pdf-2',
    type: 'pdf',
    title: 'Creepy Cable Character Designs: Faye and Thea',
    date: 'Sept 2025',
    category: 'characterdesigns',
    categoryLabel: 'characterdesigns',
    thumbnail: '/cd-faye-thea-thumb.jpg',
    pdfUrl: 'https://sewell-portfolio-v2.preview.emergentagent.com/api/pdf/character-designs-faye-thea',
    totalPages: 4
  },
  {
    id: 'pdf-4',
    type: 'pdf',
    title: 'Ryan Character Design',
    date: 'Jun. 2025',
    category: 'characterdesigns',
    categoryLabel: 'characterdesigns',
    thumbnail: '/ryan-thumb.png',
    pdfUrl: 'https://sewell-portfolio-v2.preview.emergentagent.com/api/pdf/ryan-character-design',
    totalPages: 4
  },

  // Prop Designs (newest first)
  {
    id: 'prop-1',
    type: 'image',
    title: 'Beach Umbrellas',
    date: 'Jul. 2026',
    category: 'propdesigns',
    categoryLabel: 'Prop Design',
    thumbnail: '/prop-umbrellas.png'
  },
  {
    id: 'prop-3',
    type: 'image',
    title: 'Beach Chair, Towels, and Cooler',
    date: 'Jul. 2026',
    category: 'propdesigns',
    categoryLabel: 'Prop Design',
    thumbnail: '/prop-beach-chair.png'
  },
  {
    id: 'prop-2',
    type: 'image',
    title: "King's Sceptor",
    date: 'Jun. 2026',
    category: 'propdesigns',
    categoryLabel: 'Prop Design',
    thumbnail: '/prop-sceptor.png'
  }
];
